<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="mappedItems"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Prescreen Campaign List</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <v-btn
            v-if="hasPermission('create prescreen::campaign')"
            dark
            class="mb-2 btn-bg-deep-blue"
            @click="dialogForm = true"
          >
            <v-icon>mdi-plus</v-icon>
            New Prescreen Campaign
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="New Prescreen Campaign"
            permission="create prescreen::campaign"
            :x-small="false"
            button-class="mb-2"
          />

          <PrescreenCampaignFormModal
            v-model="dialogForm"
            :edited-item="editedItem"
            :lead-providers="leadProviders"
            :campaigns="campaigns"
            @close-modal="closeModal('dialogForm')"
            @item-saved="itemSaved()"
            @click:outside="clearState()"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('edit prescreen::campaign')"
        :id="item"
        class="mr-10"
        @click="editItem(item)"
      >
        mdi-pencil-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-pencil-outline"
        :text-button="true"
        permission="edit prescreen::campaign"
        :x-small="false"
        button-class="mr-10"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

import PrescreenCampaignFormModal from './PrescreenCampaignFormModal.vue';
import DisabledForLackOfRoleBtn from '../../../DisabledForLackOfRoleBtn.vue';

export default {
  components: {
    PrescreenCampaignFormModal,
    DisabledForLackOfRoleBtn,
  },

  mixins: [
    dataTableMixin,
  ],

  data: () => ({
    headers: [
      { title: 'ID', value: 'id' },
      { title: 'Name', value: 'name' },
      { title: 'Print Date', value: 'print_expire_date' },
      { title: 'Active Date', value: 'active_date' },
      { title: 'Mail Date', value: 'mailed_date' },
      { title: 'Campaign Code', value: 'campaign_code' },
      {
        title: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'start',
        width: 183,
      },
    ],

    dialogDelete: false,
    dialogForm: false,
    editedItem: {
      id: null,
    },
    leadProviders: [],
    campaigns: {},
  }),

  computed: {
    mappedItems() {
      return (this.items || []).map((item) => ({
        ...item,
        enabled: !!item.enabled,
      }));
    },
  },

  created() {
    this.$axios
      .get('/api/v1/lead-provider', {
        params: {
          perPage: 100,
          withCampaigns: 1,
        },
      })
      .then((res) => {
        const { data } = res.data;

        this.leadProviders = data.map((item) => {
          this.campaigns[item.id] = item.campaigns.map((campaign) => ({
            value: campaign.id,
            text: campaign.campaign_name,
          }));
          return {
            value: item.id,
            text: item.company_name,
          };
        });
      });
  },

  methods: {
    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogForm = true;
    },
    itemDeleted() {
      this.items = [];
      this.updateTable();
    },
    itemSaved() {
      this.items = [];
      this.updateTable();
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/prescreen-campaign', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
  },
};
</script>
